<template>
  <div class="about">

    <section id="portada" class="animacion">
       <div class="contedor-portada">
          <div class="portada-contenido animacion">
          <h1>{{nom_sub_sec_es}}</h1>
          <ul>
            <li><router-link tag="a" to="/">Inicio</router-link></li>
            <li class="sin-division">{{nom_sub_sec_es}}</li>
          </ul>
          </div>
          <img
            class="imagen-cover"
            v-bind:src='imgPreUrl+ url_1st_image +"x640.jpg"'
            v-bind:alt='type_1st_image'>
       </div>
    </section>
    
      <section id="servicios" class="secciones seccion-blanca">        
       <div class="container">
        <h1>{{internal_name_es}}</h1>
        <div class="row">
         <div class="col-md-8">
           <span v-html="desc_sub_section_es"></span>
         </div>
         <div class="col-md-4">
           <img
            v-bind:src='imgPreUrl+ url_2nd_image +"x320.jpg"'
            v-bind:alt='type_2nd_image' 
            class="card-img-top mt-2 imagen-cover">
         </div>   
        </div>
       </div>
    </section>

    <section id="servicios" class="secciones seccion-gris">        
      <div class="container">
        <div class="row">
         <div class="col-sm-6 col-lg-4">
           <div class="card card-about">
             <div class="card-image-product">
               <img
                  v-bind:src='imgPreUrl+ url_3rd_image + "x320.jpg"'
                  v-bind:alt='type_3rd_image' 
                  class="imagen-cover">
             </div>
             <div class="card-body">
              <span v-html="text1_es"></span>
             </div>
           </div>
         </div>
         <div class="col-sm-6 col-lg-4">
           <div class="card card-about">
             <div class="card-image-product">
               <img
                  v-bind:src='imgPreUrl+ url_4th_image + "x320.jpg"'
                  v-bind:alt='type_4th_image' 
                  class="imagen-cover">
             </div>
             <div class="card-body">
               <span v-html="text2_es"></span>
             </div>
           </div>
         </div>
         <div class="col-sm-6 col-lg-4">
           <div class="card card-about">
             <div class="card-image-product">
               <img
                  v-bind:src='imgPreUrl+ url_5th_image + "x320.jpg"'
                  v-bind:alt='type_5th_image' 
                  class="imagen-cover">
             </div>
             <div class="card-body">
                <span v-html="text3_es"></span>
             </div>
           </div>
         </div>
        </div>
          
      </div>
    </section>

    <TwoModules></TwoModules>
    <Instagram></Instagram>

  </div>

</template>
<style>
.avatar {
  border-radius: 10px;
}
.card-about {
  height: 400px;
  margin-top: 20px;
}
.p-about{
 text-align: justify !important;
}
</style>


<script>
import TwoModules from "@/components/products/TwoModules.vue";
import Instagram from "@/components/products/Instagram.vue";
import axios from "axios";
import {config_settings} from '../config.js';
import _ from "lodash";
import { errorToaster } from '../components/shared/service/ErrorHandler';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;


  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  components: { TwoModules,
    Instagram },
  data() {
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

    imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
    cod_sub_sec: 9,
    nom_sub_sec_es: '',
    nom_sub_sec_en: '',
    internal_name_es: '',
    internal_name_en: '',
    desc_sub_section_es: '',
    desc_sub_section_en: '',
    section: '',
    url_1st_image: 'products/empty-img',
    url_2nd_image: 'products/empty-img',
    url_3rd_image: 'products/empty-img',
    url_4th_image: 'products/empty-img',
    url_5th_image: 'products/empty-img',
    type_1st_image: 'image',
    type_2nd_image: 'image',
    type_3rd_image: 'image',
    type_4th_image: 'image',
    type_5th_image: 'image',
    text1_es: '',
    text1_en: '',
    text2_es: '',
    text2_en: '',
    text3_es: '',
    text3_en: '',
    orientation: '',
    url_es: '',
    url_en: '',
    order_sub_section: '',
    id_position_menu: '',
    url_video: '',
    type: '',
    }
  },
  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },
  methods: {
    scroll_inicio(){
      window.scrollTo(0,0);
    },

    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 

               //SEO
              this.page_title = this.nom_sub_sec_es;
              this.page_description = this.desc_sub_section_es;
              this.page_keywords = response.data.keywords;
              
                
          })
           .catch(error => {
            console.log("error");
      })
    },
  },

  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
  }
};
</script>